module.exports = __webpack_public_path__ + "img/exclamation-point.67690776.svg";